module.exports = __webpack_public_path__ + "static/media/Illus-404@3x.a69eba9e.png";